import React, { useRef } from "react";
import notes from "../images/notes.png";
import double from "../images/double-tick.png";
import plus from "../images/plus.png";
import { useDispatch } from "react-redux";
import { clearCompleted, completeAll } from "../redux/todos/actions";

import addTodos from "../redux/todos/thunk/todoAdd";

export default function Header() {
  const inputRef = useRef(null);
  let text = "";

  const dispatch = useDispatch();
  const values = (e) => {
    text = inputRef.current.value;
    dispatch(addTodos(text));
    inputRef.current.value = "";
    console.log(text);

    e.preventDefault();
  };

  const allComplete = () => {
    dispatch(completeAll());
  };

  const clearComplete = () => {
    dispatch(clearCompleted());
  };

  return (
    <div>
      <form
        class="flex items-center bg-gray-100 px-2 py-2 rounded-md"
        onSubmit={values}
      >
        <img src={notes} class="w-6 h-6" alt="Add todo" />
        <input
          type="text"
          ref={inputRef}
          placeholder="Type your todo"
          class="w-full text-lg px-4 py-1 border-none outline-none bg-gray-100 text-gray-500"
        />
        <button
          type="submit"
          class={`appearance-none w-8 h-8 bg-[url(${plus})] bg-no-repeat bg-contain`}
        ></button>
      </form>

      <ul class="flex justify-between my-4 text-xs text-gray-500">
        <li class="flex space-x-1 cursor-pointer" onClick={allComplete}>
          <img class="w-4 h-4" src={double} alt="Complete" />
          <span>Complete All Tasks</span>
        </li>
        <li class="cursor-pointer" onClick={clearComplete}>
          Clear completed
        </li>
      </ul>
    </div>
  );
}
